import React from "react";

import {
  UploadOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import {
  Layout,
  Button,
  Pagination,
  Spin,
  Row,
  Upload,
  Modal,
  List,
} from "antd";

import Base from "../Base";

import { connect } from "react-redux";
import { getUserInfo } from "../../utils/redux/reducers/User";
import { Locale } from "../../utils";

class ImportProduct extends Base {
  constructor(props) {
    super(props);

    this.afterSomeSecond = 1;
    this.state = {
      ...this.state,

      list: null,
      loadingList: false,
      currentPage: this.getRouterQueryPage(),
      currentPageSize: this.getRouterQueryPageSize(),

      showError4Id: null,
      checkingZero: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.getUser()) {
      this.showMessage(
        this.i18n.t("financeDownload.loadingData"),
        Base.Message.loading
      );
      this.loadList();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate(prevProps, prevState);

    if (
      prevState.currentPage !== this.state.currentPage ||
      prevState.currentPageSize !== this.state.currentPageSize
    ) {
      this.showMessage(
        this.i18n.t("financeDownload.loadingData"),
        Base.Message.loading
      );
      this.loadList();

      this.setRouterQuery({
        page: this.state.currentPage,
        pageSize: this.state.currentPageSize,
      });
    }
  }

  render() {
    return (
      <Layout id="route-finance-download">
        {this._renderHeader()}
        {this._renderHistoryContent()}
        {this._renderModal()}
      </Layout>
    );
  }

  _renderHeader() {
    let locale = Locale.getLocale();
    if (locale === Locale.Locales.ug.locale) {
      locale = ``;
    } else {
      locale = `/${locale}`;
    }

    const url = `${locale}/api/v4/merchant/product/import-excel`;

    const uploadProps = {
      accept: ".xls, .xlsx, .csv",
      action: url,
      headers: {
        authorization: this.getUserToken(),
      },
      onChange: (info) => {
        if (info.file.status !== "uploading") {
          this.showMessage(
            this.i18n.t("importExecl.importing"),
            Base.Message.loading
          );
        }

        if (info.file.status === "done") {
          const { response } = info.file;
          if (response.result) {
            this.checkStatusZero(response.data.id);
          } else if (response.message) {
            this.showMessage(response.message, Base.Message.error);
          }
        } else if (info.file.status === "error") {
          const message =
            info.file.response && info.file.response.message
              ? info.file.response.message
              : this.i18n.t("importExecl.historyItemStatusFailed");
          this.showMessage(message, Base.Message.error);
        }
      },
    };

    return (
      <Row
        gutter={10}
        style={{ marginLeft: 0, marginRight: 0, marginBottom: 10 }}
      >
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />} type="primary">
            {this.i18n.t("main.sideMenus.import")}
          </Button>
        </Upload>
        <Button
          icon={<DownloadOutlined />}
          href="/templates/product-import-template.csv"
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.i18n.t("productImport.downloadTemplate")}
        </Button>
      </Row>
    );
  }

  _renderHistoryContent() {
    return (
      <div className="history-wrap">
        {this._renderHistoryHeader()}
        {this._renderHistoryList()}
        {this._renderHistoryPagination()}
      </div>
    );
  }

  _renderHistoryHeader() {
    return (
      <div className="history-header">
        <span className="no">
          {this.i18n.t("financeDownload.historyHeaderNo")}
        </span>
        <span className="name">
          {this.i18n.t("financeDownload.historyHeaderName")}
        </span>
        <span className="date">{this.i18n.t("orderDownload.date")}</span>
        <span className="count">
          {this.i18n.t("productImport.productCount")}
        </span>
        <span className="status">
          {this.i18n.t("financeDownload.historyHeaderStatus")}
        </span>
        <span className="actions">
          {this.i18n.t("financeDownload.historyHeaderActions")}
        </span>
      </div>
    );
  }

  _renderHistoryList() {
    let data = this.state.list;
    if (data) {
      let list = data ? data.data : null;
      if (list && list.length > 0) {
        return (
          <Spin spinning={this.state.loadingList || this.state.checkingZero}>
            <div className="history-list">
              {list.map((item, index) => {
                let statusClassName = "";
                let statusIconType = "";
                let statusText = "";
                let actions = [];

                if (item.status === 0) {
                  statusClassName = "status progress";
                  statusIconType = <ClockCircleOutlined />;
                  statusText = this.i18n.t(
                    "financeDownload.historyItemStatusGenerating"
                  );
                } else if (item.status === 1) {
                  statusClassName = "status";
                  statusIconType = <CheckCircleOutlined />;
                  statusText = this.i18n.t(
                    "importExecl.historyItemStatusSuccess"
                  );
                } else if (item.status === 2) {
                  statusClassName = "status error";
                  statusIconType = <CloseCircleOutlined />;
                  statusText = this.i18n.t(
                    "importExecl.historyItemStatusFailed"
                  );
                  if (item.download_url) {
                    actions.push(
                      <a
                        key="action-download"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={item.download_url}
                      >
                        {this.i18n.t(
                          "financeDownload.historyItemActionDownload"
                        )}
                      </a>
                    );
                  }
                  actions.push(
                    <Button
                      key="action-check"
                      onClick={() => this.onShowImportError(item.id)}
                      style={{ borderWidth: 0 }}
                    >
                      {this.i18n.t("order.importErrorCheck")}
                    </Button>
                  );
                }

                return (
                  <div
                    key={`list-item-${index}`}
                    className="history-header item"
                  >
                    <span className="no">{item.id}</span>
                    <span className="name">{item.file_name}</span>
                    <span className="date">{item.created_at}</span>
                    <span className="count">{item.products_count}</span>
                    <span className={statusClassName}>
                      {statusIconType}
                      <span>{statusText}</span>
                    </span>
                    <span className="actions">{actions}</span>
                  </div>
                );
              })}
            </div>
          </Spin>
        );
      } else {
        return (
          <div className="history-list">
            <div className="list-message">
              {this.i18n.t("financeDownload.loadingEmpty")}
            </div>
          </div>
        );
      }
    } else {
      if (this.state.loadingList) {
        return (
          <div className="history-list">
            <div className="list-message">
              {this.i18n.t("financeDownload.loadingData")}
            </div>
          </div>
        );
      }

      return (
        <div className="history-list">
          <div className="list-message">
            {this.i18n.t("financeDownload.loadingEmpty")}
          </div>
        </div>
      );
    }
  }

  _renderHistoryPagination() {
    let data = this.state.list;
    if (data && data.data && data.data.length > 0) {
      return (
        <div className="history-pagination">
          <Pagination
            total={data.total}
            current={this.state.currentPage}
            showSizeChanger={true}
            pageSizeOptions={["10", "20", "30"]}
            pageSize={this.state.currentPageSize}
            onChange={this.onPaginationPageChange}
            onShowSizeChange={this.onPaginationPageSizeChange}
            showQuickJumper
          />
        </div>
      );
    } else {
      return null;
    }
  }

  _renderModal() {
    const { list, showError4Id } = this.state;
    if (!showError4Id) return null;

    const item = list.data.filter((item) => item.id === showError4Id);
    const renderData = !item.length ? null : item[0].extra;
    if (!renderData) return null;

    return (
      <Modal
        className="route-order-list-send-modal"
        open={!!showError4Id}
        title={this.i18n.t("importExecl.errorTitle")}
        onOk={() => this.setState({ showError4Id: null })}
        onCancel={() => this.setState({ showError4Id: null })}
      >
        <Layout className="order-send-wrap">
          <List
            bordered
            itemLayout="vertical"
            dataSource={renderData}
            renderItem={(item) => <List.Item>{item}</List.Item>}
          />
        </Layout>
      </Modal>
    );
  }

  onPaginationPageChange = (page, pageSize) => {
    this.setState({ currentPage: page });
  };

  onPaginationPageSizeChange = (page, pageSize) => {
    this.setState({ currentPageSize: pageSize, currentPage: 1 });
  };

  onShowImportError = (id) => {
    this.setState({ showError4Id: id });
  };

  async loadList() {
    if (this.state.loadingList) return;

    let token = this.getUserToken();
    if (!token) return;

    let api = this.api.product.listImportExcels;
    let apiConfig = {
      token: token,
      query: {
        page: this.state.currentPage,
        count: this.state.currentPageSize,
        "filter[type]": 1,
      },
    };

    this.setState({ loadingList: true });
    try {
      let res = await api.run(apiConfig);

      if (!this.mounted) return;

      if (res.result) {
        let data = res.data;
        this.setState({ list: data });

        let list = data ? data.data : null;
        if (list && list.length > 0) {
          let generatingBill = list.find((item) => item.status === 0);
          if (generatingBill) {
            setTimeout(() => {
              if (!this.mounted) return;

              this.showMessage(
                this.i18n.t("financeDownload.updatingList"),
                Base.Message.loading
              );
              this.loadList();
            }, 5000);
          }
        }
      } else {
        this.showMessage(res.message, Base.Message.error);
      }
    } catch (error) {
      if (!this.mounted) return;
      this.handleApiError(api, error);
    } finally {
      if (!this.mounted) return;
      this.setState({ loadingList: false });
    }
  }

  checkStatusZero = async (id) => {
    if (this.state.checkingZero) return;

    let token = this.getUserToken();
    if (!token) return;

    let api = this.api.product.importDetail;
    let apiConfig = {
      token: token,
      path: {
        id,
      },
    };

    this.setState({ checkingZero: true });
    try {
      let res = await api.run(apiConfig);

      if (!this.mounted) return;

      if (res.result) {
        if (res.data.status === 0) {
          setTimeout(() => {
            if (!this.mounted) return;
            this.checkStatusZero(res.data.id);
          }, 2000);
        } else {
          this.loadList();
          if (res.data.status === 1) {
            this.showMessage(
              this.i18n.t("importExecl.historyItemStatusSuccess"),
              Base.Message.success
            );
          } else if (res.data.status === 2) {
            this.showMessage(
              this.i18n.t("importExecl.historyItemStatusFailed"),
              Base.Message.error
            );
          }
        }
      } else {
        this.showMessage(res.message, Base.Message.error);
      }
    } catch (error) {
      if (!this.mounted) return;
      this.handleApiError(api, error);
    } finally {
      if (!this.mounted) return;
      this.setState({ checkingZero: false });
    }
  };
}

export default connect((state) => {
  return {
    user: getUserInfo(state),
  };
})(ImportProduct);
